import React, { useEffect, useState } from "react";
import "../styles/MatrimonialRegistrationPage.css";
import bhriguLogo from "../assets/images/bhrigu-logo.gif";
import pic1 from "../assets/images/matrimonial-pic1.png";
import pic2 from "../assets/images/matrimonial-pic2.png";
import pic3 from "../assets/images/matrimonial-pic3.png";
import config from "../services/config";
import { showAlert } from "../utilities/alertService";
import { useNavigate } from "react-router-dom";
import Loader from "../utilities/Loader";

const MatrimonialRegistrationPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    time: "",
    placeOfBirth: "",
    gender: "",
    education1: "",
    education2: "",
    profession: "",
    income: "",
    height: "",
    weight: "",
    complexion: "",
    bloodGroup: "",
    gotra: "",
    kuldevi: "",
    fatherName: "",
    fatherOccupation: "",
    motherName: "",
    motherOccupation: "",
    sibling1: "",
    sibling2: "",
    sibling3: "",
    dadaji: "",
    dadiji: "",
    nanaji: "",
    naniji: "",
    reference1: "",
    reference2: "",
    reference3: "",
    reference4: "",
    correspondenceAddress: "",
    email: "",
    phone: "",
  });
  const [uploadedImages, setUploadedImages] = useState({
    pic1: null,
    pic2: null,
    pic3: null,
  });
  const [errors, setErrors] = useState({});
  const [imageErrors, setImageErrors] = useState("");
  const [kuldeviOptions, setKuldeviOptions] = useState([]);
  const [gotraOptions, setGotraOptions] = useState([]);

  const requiredFields = [
    "name", "dob", "time", "placeOfBirth", "gender", "education1", "profession",
    "monthlyIncome", "height", "weight", "complexion", "bloodGroup", "gotra", "kuldevi",
    "fatherName", "motherName", "dadaji", "dadiji", "nanaji", "naniji",
    "correspondenceAddress", "email", "phone"
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validate = () => {
    let tempErrors = {};
    requiredFields.forEach(field => {
      if (!formData[field]?.trim()) {
        tempErrors[field] = "This field is required";
      }
    });
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handlePhotoChange = (e, key) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setUploadedImages(prev => ({
          ...prev,
          [key]: reader.result   // Base64 string
        }));
      };

      reader.readAsDataURL(file);
      setImageErrors("");
    }
  };

  useEffect(() => {
    getkuldeviOptions();
    getGotraOptions();
  }, []);

  const getkuldeviOptions = async () => {
    try {
      const response = await config.getActiveKuldevi();

      if (response.status) {
        setKuldeviOptions(response.data);
      } else {
        showAlert("error", "Failed to fetch Kuldevi options");
      }

    } catch (error) {
      showAlert("error", "An error occurred while fetching Kuldevi options");
    }
  };

  const getGotraOptions = async () => {
    try {
      const response = await config.getActiveGotra();
      if (response.status) {
        setGotraOptions(response.data);
      } else {
        showAlert("error", "Failed to fetch Gotra options");
        return [];
      }
    } catch (error) {
      showAlert("error", "An error occurred while fetching Gotra options");
      return [];
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const isFormValid = validate();
      if (!uploadedImages.pic1 || !uploadedImages.pic2 || !uploadedImages.pic3) {
        setImageErrors("All three photographs are required");
        return;
      }
      if (!isFormValid) return;

      const payload = {
        company_id: 1,
        name: formData.name,
        date_of_birth: formData.dob,
        time_of_birth: formData.time,
        place_of_birth: formData.placeOfBirth,
        gender: formData.gender,
        highest_education_one: formData.education1,
        highest_education_two: formData.education2,
        profession: formData.profession,
        monthly_income: formData.monthlyIncome,
        height: formData.height,
        weight: formData.weight,
        complexion: formData.complexion,
        blood_group: formData.bloodGroup,
        gotra_id: formData.gotra,
        kuldevi_id: formData.kuldevi,
        father_name: formData.fatherName,
        father_occupation: formData.fatherOccupation,
        mother_name: formData.motherName,
        mother_occupation: formData.motherOccupation,
        sibling1: formData.sibling1,
        sibling2: formData.sibling2,
        sibling3: formData.sibling3,
        dadaji: formData.dadaji,
        dadiji: formData.dadiji,
        nanaji: formData.nanaji,
        naniji: formData.naniji,
        references1: formData.reference1,
        references2: formData.reference2,
        references3: formData.reference3,
        correspondence_address: formData.correspondenceAddress,
        email: formData.email,
        phone: formData.phone,
        self_or_other: "self",
        status: true,
        image1: uploadedImages.pic1,
        image2: uploadedImages.pic2,
        image3: uploadedImages.pic3
      };
      const response = await config.bandhanRegistration(payload);

      if (response.status) {
        showAlert(
          "success",
          `Registration successful. Your Registration ID is ${response.data.registration_no}. Please check your inbox for your Unique Code.`
        );
        // ✅ Reset form fields
        setFormData({
          name: "",
          dob: "",
          time: "",
          placeOfBirth: "",
          gender: "",
          education1: "",
          education2: "",
          profession: "",
          monthlyIncome: "",
          height: "",
          weight: "",
          complexion: "",
          bloodGroup: "",
          gotra: "",
          kuldevi: "",
          fatherName: "",
          fatherOccupation: "",
          motherName: "",
          motherOccupation: "",
          sibling1: "",
          sibling2: "",
          sibling3: "",
          dadaji: "",
          dadiji: "",
          nanaji: "",
          naniji: "",
          reference1: "",
          reference2: "",
          reference3: "",
          correspondenceAddress: "",
          email: "",
          phone: ""
        });
        // ✅ Reset images
        setUploadedImages({
          pic1: "",
          pic2: "",
          pic3: ""
        });
        setImageErrors("");
        navigate("/"); // Redirect to home or any other page after successful registration
      } else {
        showAlert("error", response.message || "Registration failed. Please try again.");
      }
    } catch (error) {
      console.error("Submission Error:", error);
      console.error(error.message || "Error submitting form");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="matrimonial-page">
      {loading && <Loader />}
      <div className="container-matrimonial">
        {/* LEFT PANEL */}
        <div className="col-70 profileleftpanel">
          <div className="row">
            <div className="col-15">
              <button>Self</button>
              <br />
              <button>Other</button>
            </div>
            <div className="col-75 animated-title">
              <h2>Registration for Bandhan Sutra</h2>
            </div>
          </div>

          <div className="row">
            {/* LEFT FORM COLUMN */}
            <div className="col-50">
              <div className="form-row">
                <input type="text" placeholder="Name *" name="name" onChange={handleChange} />
                {errors.name && <span className="error">{errors.name}</span>}
              </div>

              <div className="form-row">
                <div className="row">
                  <div className="col-60">
                    <input
                      type="date"
                      placeholder="Date of Birth *"
                      name="dob"
                      onChange={handleChange}
                    />
                    {errors.dob && <span className="error">{errors.dob}</span>}
                  </div>
                  <div className="col-40">
                    <input type="time" placeholder="Time *" name="time" onChange={handleChange} />
                    {errors.time && <span className="error">{errors.time}</span>}
                  </div>
                </div>
              </div>

              <div className="form-row">
                <div className="row">
                  <div className="col-60">
                    <input type="text" placeholder="Place of Birth *" name="placeOfBirth" onChange={handleChange} />
                    {errors.placeOfBirth && <span className="error">{errors.placeOfBirth}</span>}</div>
                  <div className="col-40">
                    <select name="gender" value={formData.gender} onChange={handleChange}>
                      <option value="">Select Gender *</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                    {errors.gender && <span className="error">{errors.gender}</span>}</div>
                </div>
              </div>

              <div className="form-row">
                <input type="text" placeholder="Highest Education 1 *" name="education1" onChange={handleChange} />
                {errors.education1 && <span className="error">{errors.education1}</span>}</div>
              <div className="form-row">
                <input type="text" placeholder="Highest Education 2" name="education2" onChange={handleChange} /></div>
              <div className="form-row">
                <input type="text" placeholder="Profession *" name="profession" onChange={handleChange} />
                {errors.profession && <span className="error">{errors.profession}</span>}</div>
              <div className="form-row">
                <input type="text" placeholder="Monthly Income in Rs. *" name="monthlyIncome" onChange={handleChange} />
                {errors.monthlyIncome && <span className="error">{errors.monthlyIncome}</span>}</div>

              <div className="form-row">
                <div className="row">
                  <div className="col-48">
                    <input type="text" placeholder="Height in Feet *" name="height" onChange={handleChange} />
                    {errors.height && <span className="error">{errors.height}</span>}</div>
                  <div className="col-48">
                    <input type="text" placeholder="Weight in Kg *" name="weight" onChange={handleChange} />
                    {errors.weight && <span className="error">{errors.weight}</span>}</div>
                </div>
              </div>

              <div className="form-row">
                <div className="row">
                  <div className="col-48">
                    {/* <input type="text" placeholder="Complexion *" name="complexion" onChange={handleChange} /> */}
                    <select name="complexion" value={formData.complexion} onChange={handleChange}>
                      <option value="">Select Complexion *</option>
                      <option value="very_fair">Very Fair</option>
                      <option value="fair">Fair</option>
                      <option value="wheatish_fair">Wheatish Fair</option>
                      <option value="wheatish">Wheatish</option>
                      <option value="medium">Medium</option>
                      <option value="dusky">Dusky</option>
                    </select>
                    {errors.complexion && <span className="error">{errors.complexion}</span>}
                  </div>
                  <div className="col-48">
                    {/* <input type="text" placeholder="Blood Group *" name="bloodGroup" onChange={handleChange} /> */}
                    <select name="bloodGroup" value={formData.bloodGroup} onChange={handleChange}>
                      <option value="">Select Blood Group *</option>
                      <option value="A+">A+</option>
                      <option value="A-">A-</option>
                      <option value="B+">B+</option>
                      <option value="B-">B-</option>
                      <option value="AB+">AB+</option>
                      <option value="AB-">AB-</option>
                      <option value="O+">O+</option>
                      <option value="O-">O-</option>
                    </select>
                    {errors.bloodGroup && <span className="error">{errors.bloodGroup}</span>}</div>
                </div>
              </div>

              <div className="form-row">
                <div className="row">
                  <div className="col-48">
                    <select name="gotra" onChange={handleChange} value={formData.gotra}>
                      <option value="">Select Gotra *</option>
                      {gotraOptions.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                    {errors.gotra && <span className="error">{errors.gotra}</span>}</div>
                  <div className="col-48">
                    <select name="kuldevi" onChange={handleChange} value={formData.kuldevi}>
                      <option value="">Select Kuldevi *</option>
                      {kuldeviOptions.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                    {errors.kuldevi && <span className="error">{errors.kuldevi}</span>}</div>
                </div>
              </div>

              <div className="form-row">
                <input type="text" placeholder="Father’s Name *" name="fatherName" onChange={handleChange} />
                {errors.fatherName && <span className="error">{errors.fatherName}</span>}</div>
              <div className="form-row">
                <input type="text" placeholder="Occupation" name="fatherOccupation" onChange={handleChange} /></div>
              <div className="form-row">
                <input type="text" placeholder="Mother’s Name *" name="motherName" onChange={handleChange} />
                {errors.motherName && <span className="error">{errors.motherName}</span>}</div>
              <div className="form-row">
                <input type="text" placeholder="Occupation" name="motherOccupation" onChange={handleChange} /></div>
            </div>

            {/* RIGHT FORM COLUMN */}
            <div className="col-50">
              <div className="form-row">
                <input type="text" placeholder="Sibling 1" name="sibling1" onChange={handleChange} /></div>
              <div className="form-row">
                <input type="text" placeholder="Sibling 2" name="sibling2" onChange={handleChange} /></div>
              <div className="form-row">
                <input type="text" placeholder="Sibling 3" name="sibling3" onChange={handleChange} /></div>
              <div className="form-row">
                <input type="text" placeholder="Dadaji *" name="dadaji" onChange={handleChange} />
                {errors.dadaji && <span className="error">{errors.dadaji}</span>}</div>
              <div className="form-row">
                <input type="text" placeholder="Dadiji *" name="dadiji" onChange={handleChange} />
                {errors.dadiji && <span className="error">{errors.dadiji}</span>}</div>
              <div className="form-row">
                <input type="text" placeholder="Nanaji *" name="nanaji" onChange={handleChange} />
                {errors.nanaji && <span className="error">{errors.nanaji}</span>}</div>
              <div className="form-row">
                <input type="text" placeholder="Naniji *" name="naniji" onChange={handleChange} />
                {errors.naniji && <span className="error">{errors.naniji}</span>}</div>

              <div className="form-row">
                <input type="text" placeholder="References" name="reference1" onChange={handleChange} /></div>
              <div className="form-row">
                <input type="text" placeholder="References" name="reference2" onChange={handleChange} /></div>
              <div className="form-row">
                <input type="text" placeholder="References" name="reference3" onChange={handleChange} /></div>
              <div className="form-row">
                <input type="text" placeholder="References" name="reference4" onChange={handleChange} /></div>

              {/* <div className="form-row"><input type="text" placeholder="Correspondence Address" /></div> */}
              <div className="form-row">
                <textarea placeholder="Correspondence Address *" rows={5} className="form-textarea" name="correspondenceAddress" onChange={handleChange} />
                {errors.correspondenceAddress && <span className="error">{errors.correspondenceAddress}</span>}</div>
              {/* <div className="form-row"><input type="text" placeholder="Correspondence Address" /></div> */}

              <div className="form-row">
                <div className="row">
                  <div className="col-48">
                    <input type="email" placeholder="Email *" name="email" onChange={handleChange} />
                    {errors.email && <span className="error">{errors.email}</span>}</div>
                  <div className="col-48">
                    <input type="tel" placeholder="Phone *" name="phone" onChange={handleChange} />
                    {errors.phone && <span className="error">{errors.phone}</span>}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="col-30">
          <div className="col-100 logo-div text-center">
            <img src={bhriguLogo} alt="Bhrigu" />
          </div>
          <div className="row matrimonial-img-div">
            <div className="martinomial-img">
              <div className="row">
                <div className="leftpanelimgcontainer">

                  <div className="martfigure">
                    <label>
                      <img
                        src={uploadedImages.pic1 || pic1}
                        alt="Matrimonial 1"
                      />
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={(e) => handlePhotoChange(e, "pic1")}
                      />
                    </label>
                  </div>

                  <div className="martfigure">
                    <label>
                      <img
                        src={uploadedImages.pic2 || pic2}
                        alt="Matrimonial 2"
                      />
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={(e) => handlePhotoChange(e, "pic2")}
                      />
                    </label>
                  </div>

                </div>

                <div className="rightpanelimgcontainer">
                  <div className="martfigure">
                    <label>
                      <img
                        src={uploadedImages.pic3 || pic3}
                        alt="Matrimonial 3"
                      />
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={(e) => handlePhotoChange(e, "pic3")}
                      />
                    </label>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div className="col-100 profile-pic">
            {imageErrors && (
              <div className="error">
                {imageErrors}
              </div>
            )}
            <caption>Please attach 3 pictures as shown in the boxes.</caption>
          </div>

          <div className="col-100 text-center submission-div">
            <button type="submit" onClick={handleSubmit}>Submit</button>
            <p>
              Please check your mail after
              <br />
              successful submission
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatrimonialRegistrationPage;
